import { IntlShape, useIntl } from 'react-intl';
import { FilterChips } from 'components/FilterChips/FilterChips';
import { clearSelectedReconcileRecords } from 'pages/ReconciliationReportPage/slice';
import { useAppDispatch } from 'store/hooks';
import { STATUS } from './constants';
import { messages } from './messages';
import { options } from './options';
import { ReconciliationStatusFilterChipsProps } from './types';

export const ReconciliationStatusFilterChips = ({
  handleReciliationStatusFilter,
  paymentStatus
}: ReconciliationStatusFilterChipsProps): React.JSX.Element => {
  const intl: IntlShape = useIntl();
  const dispatch = useAppDispatch();

  const handleReciliationStatus = (selectedStatus: string[]) => {
    handleReciliationStatusFilter(selectedStatus);
    dispatch(clearSelectedReconcileRecords());
  };

  return (
    <FilterChips
      testId={STATUS}
      handleChange={handleReciliationStatus}
      options={options(intl)}
      value={paymentStatus}
      message={messages.status}
    />
  );
};
